module.exports = __webpack_public_path__ + "img/ff-logo.954146e6.png";